import './Item.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowDown, faArrowUp } from '@fortawesome/pro-solid-svg-icons';
import { Style } from './financialsModel';

export type Props = {
  title?: string
  amount: string | null
  type: string
  style?: Style
}

export default function Item({ title, amount, type, style }: Props) {
  let arrow = <></>
  if (style && style.up) {
    arrow = <FontAwesomeIcon icon={faArrowUp} style={{ fontSize: '10px', color: '#000' }} />
  } else if (style && style.down) {
    arrow = <FontAwesomeIcon icon={faArrowDown} style={{ fontSize: '10px', color: '#000' }} />
  }

  let cssClass = ""
  if (style && style.positive) {
    cssClass = "financial-item-positive"
  } else if (style && style.negative) {
    cssClass = "financial-item-negative"
  }

  return (
    <div className="financial-item">
      <h3>{title}</h3>
      <span className={cssClass}>
        {amount}
        <small className={cssClass}>{arrow} {type}</small>
      </span>
    </div>
  );
}
